import styled from 'styled-components';

import { colors } from '~/styles/colors';

export const PageTitle = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  color: ${colors.Black};
  margin-left: 15px;
`;
